<template>
  <div class="home-dashboard-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Dashboard</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-form-row>
          <b-col cols="12" sm="6" md="4">
            <b-row>
              <b-col cols="12">
                <div class="box-cj">
                  <div class="header">
                    <p class="title"><i class="far fa-calendar-alt mr-2"></i>Agendas</p>
                  </div>
                  <div class="content p-0">
                    <table class="table table-responsive agendas-table w-100 d-table main-table-cj mb-0">
                      <tbody>
                      <tr v-for="agenda in dashboardData.agendas" :key="agenda.id" @click="openAgenda(agenda.id)">
                        <td class="align-middle">{{ agenda.name }}</td>
                      </tr>
                      <tr v-if="dashboardData.agendas.length == 0">
                        <td class="align-middle text-center">Não há nenhuma agenda cadastrada</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" v-if="user && user.person.client.directing_enabled && (user.person.type != 'PROFESSIONAL' || helpers.isOwner())">
                <div class="box-cj">
                  <div class="header">
                    <p class="title"><i class="fas fa-map-marker-alt mr-2"></i>Setores</p>
                  </div>
                  <div class="content p-0">
                    <table class="table table-responsive directing-sectors-table w-100 d-table main-table-cj mb-0">
                      <tbody>
                      <tr v-for="sector in dashboardData.directing_sectors" :key="sector.id">
                        <td class="align-middle p-0">
                          <router-link tag="a" class="sector-link" target="_blank" :to="'/setores/' + sector.id">
                            {{ sector.name }}
                            <b-badge class="float-right" pill v-if="sector.pending_directings_count > 0">{{ sector.pending_directings_count }}</b-badge>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="dashboardData.directing_sectors.length == 0">
                        <td class="align-middle text-center">Não há nenhum setor cadastrado</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <div class="box-cj">
              <div class="header">
                <p class="title"><i class="far fa-sticky-note mr-2"></i>Lembretes</p>
              </div>
              <div class="content p-0">
                <table class="table table-responsive reminder-table w-100 d-table main-table-cj mb-0">
                  <tbody>
                  <tr class="position-relative" v-for="reminder in dashboardData.reminders" :key="reminder.id" @click="showReminderOptions(reminder, $event)">
                    <td class="align-middle">
                      <div class="d-flex align-items-center">
                        <div class="mr-3">{{ moment(reminder.date).format('DD/MM') }}</div>
                        <div class="flex-grow-1" :class="reminder.pending ? '' : 'line-through'">
                          <div class="mb-1"><i class="far fa-user"></i> {{ reminder.patient }}</div>
                          <div v-if="reminder.person" class="mb-1"><i class="far fa-user-tie"></i> {{ reminder.person }}</div>
                          <div class="mb-1"><i class="far fa-tag"></i> {{ reminder.type }}</div>
                          <div class="reminder-description" v-if="reminder.description">{{ reminder.description }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="dashboardData.reminders.length == 0">
                    <td class="align-middle text-center">Não há nenhum lembrete próximo</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <div class="box-cj">
              <div class="header">
                <p class="title"><i class="fas fa-birthday-cake mr-2"></i>Aniversariantes do Mês</p>
              </div>
              <div class="content p-0">
                <table class="table table-responsive birthday-table w-100 d-table main-table-cj mb-0">
                  <tbody>
                  <tr class="position-relative" v-for="person in dashboardData.birthdays" :key="person.id" @click="showBirthdayOptions(person, $event)">
                    <td class="align-middle">{{ moment(person.birthday).format('DD/MM') }} - {{ person.name }}</td>
                  </tr>
                  <tr v-if="dashboardData.birthdays.length == 0">
                    <td class="align-middle text-center">Não há nenhum aniversariante este mês</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
          <b-col cols="12" v-if="user && user.person.client.directing_enabled && user.person.type == 'PROFESSIONAL' && !helpers.isOwner()">
            <div class="box-cj">
              <div class="header">
                <p class="title"><i class="fas fa-directions mr-2"></i>Encaminhamentos</p>
              </div>
              <div class="content p-0">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj mb-0">
                  <thead>
                  <tr>
                    <th>Data / Hora</th>
                    <th>Setor</th>
                    <th>Paciente</th>
                    <th>Profissional</th>
                    <th>Agenda</th>
                    <th>Status</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <template>
                    <tr v-for="directing in dashboardData.pending_directings" :key="directing.id">
                      <td class="align-middle">{{ moment(directing.start_datetime).format('DD/MM HH:mm') }}</td>
                      <td class="align-middle">{{ dashboardData.directing_sectors.find(sector => sector.id == directing.directing_sector_id).name }}</td>
                      <td class="align-middle">
                        {{ directing.patient.name }}<br/>
                        <small>
                          {{ directing.patient.cellphone }}
                        </small>
                      </td>
                      <td class="align-middle">{{ directing.appointment.professional.name }}</td>
                      <td class="align-middle">{{ directing.appointment.agenda.name }}</td>
                      <td class="align-middle" v-html="getStatusTag(directing)"></td>
                      <td class="align-middle"><b-button v-if="directing.call_datetime == null" variant="success" @click="callDirecting(directing)">Chamar</b-button></td>
                      <td class="align-middle"><b-button variant="primary" @click="showDirectingModal(directing)">Encaminhar</b-button></td>
                      <td class="align-middle"><b-button variant="danger" @click="endDirecting(directing)">Encerrar</b-button></td>
                    </tr>
                    <tr v-if="dashboardData.pending_directings.length == 0">
                      <td colspan="9" class="align-middle text-center">Não há nenhum encaminhamento pendente</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-form-row>
      </div>
    </b-container>
    <div class="backdrop" v-if="selectedBirthdayPerson != null" @click="removeBirthdayPersonSelection"></div>
    <div class="backdrop" v-if="selectedReminder != null" @click="removeReminderSelection"></div>

    <b-modal id="directing-modal" class="directing-modal" :modalClass="'directing-modal'" @hidden="resetDirectingModal">
      <template slot="modal-header">
        Encaminhar paciente
      </template>
      <template slot="default">
        <validation-observer ref="directingForm" v-slot="{ invalid }">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Setor</label>
              <validation-provider name="setor" :rules="{ required: true }" v-slot="{ errors }">
                <multiselect v-model="directingForm.directing_sector" :options="directingSectorOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" @select="sectorSelected" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="directingForm.directing_sector != null && directingSectorProfessionalOptions.length > 0">
            <b-col>
              <label class="cj-label">Profissional (opcional)</label>
              <validation-provider name="profissional" :rules="{ required: false }" v-slot="{ errors }">
                <multiselect v-model="directingForm.professional" :options="directingSectorProfessionalOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="true" :showLabels="false" :searchable="true" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                  <template slot="clear">
                    <div class="multiselect__clear" v-if="directingForm.professional != null" @mousedown.prevent.stop="directingForm.professional = null"></div>
                  </template>
                </multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('directing-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveDirecting">Encaminhar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        selectedBirthdayPerson: null,
        selectedReminder: null,
        // canSee: true,
        // canAdd: true,
        // canEdit: true,
        // canRemove: true,

        canPerformAction: true,

        dashboardData: {
          agendas: [],
          birthdays: [],
          reminders: [],
          directing_sectors: [],
          pending_directings: [],
        },

        directingSectorOptions: [],
        directingSectorProfessionals: {},
        directingSectorProfessionalOptions: [],

        directingForm: {
          id: null,
          agenda_id: null,
          directing_sector: null,
          professional: null,
        }
      }
    },
    mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));
      // this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_see');
      // this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_add');
      // this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_edit');
      // this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_remove');
      //
      // if(this.canSee == false) {
      //   this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
      //   this.$router.push({ path: '/' }).catch(() => {});
      //   return;
      // }

      this.eventBus.$emit('IS_LOADING', true);
      this.api.getHomeDashboardData().then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.dashboardData = res.data;

        if(this.user.person.client.directing_enabled && this.user.person.type == 'PROFESSIONAL' && !this.helpers.isOwner()) {
          this.directingSectorOptions = [];
          this.directingSectorProfessionals = {};
          res.data.directing_sectors.forEach(directingSector => {
            this.directingSectorOptions.push({value: directingSector.id, name: directingSector.name});
            this.directingSectorProfessionals[directingSector.id] = [];
            directingSector.professionals.forEach(professional => {
              this.directingSectorProfessionals[directingSector.id].push({value: professional.id, name: professional.name, agenda_ids: professional.agendas.map(agenda => agenda.id)});
            });
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Home Dashboard Data', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as suas informações! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Home Dashboard Data', err.response);
      });
    },
    methods: {
      openAgenda(agendaId) {
        let appointmentsData = {
          agenda_id: agendaId,
          view: 'week',
          start_date: this.moment().subtract(1, 'days').format('YYYY-MM-DD')
        };
        localStorage.setItem('appointmentsData', JSON.stringify(appointmentsData));
        this.$router.push('/').catch(() => {});
      },

      showBirthdayOptions(person, event) {
        if(!person.cellphone) {
          return;
        }
        this.selectedBirthdayPerson = person;
        let element = event.target;
        while(element.tagName !== 'TR') {
          element = element.parentNode;
        }
        let elementAttr = element.getBoundingClientRect();
        let divClass = [];
        if(elementAttr.right + 150 >= window.innerWidth) {
          divClass.push('left');
        }

        if(elementAttr.top + 205 >= window.innerHeight) {
          divClass.push('bottom');
        }

        if(this.$attrs['isMobile']) {
          divClass.push('mobile');
        }

        let quickActionList = '' +
            '<div id="quickActionList" class="'+divClass.join(' ')+'">' +
              '<ul>' +
                '<li class="whatsapp" data-type="birthday"><i class="fab fa-whatsapp"></i> Enviar WhatsApp</li>' +
              '</ul>' +
            '</div>';

        element.insertAdjacentHTML('beforeend', quickActionList);
        element.id = 'listItemSelected';

        let els = document.querySelectorAll('#quickActionList > ul > li');

        els.forEach(el => {
          el.addEventListener('click', (event) => {
            if(el.className != 'edit')
              event.stopPropagation();

            this.callQuickAction(el.className, el.getAttribute('data-type'));
          });
        });
      },

      showReminderOptions(reminder, event) {
        if(this.user == null || (this.user.person.type !== 'PROFESSIONAL' && this.user.person.type !== 'COORDINATOR' && this.user.person.type !== 'SECRETARY')) {
          return;
        }
        this.selectedReminder = reminder;
        let element = event.target;
        while(element.tagName !== 'TR') {
          element = element.parentNode;
        }
        let elementAttr = element.getBoundingClientRect();
        let divClass = [];
        if(elementAttr.right + 150 >= window.innerWidth) {
          divClass.push('left');
        }

        if(elementAttr.top + 205 >= window.innerHeight) {
          divClass.push('bottom');
        }

        if(this.$attrs['isMobile']) {
          divClass.push('mobile');
        }

        let quickActionList = '' +
            '<div id="quickActionList" class="'+divClass.join(' ')+'">' +
              '<ul>';

        if(reminder.cellphone) {
          quickActionList += '<li class="whatsapp" data-type="reminder"><i class="fab fa-whatsapp"></i> Enviar WhatsApp</li>';
        }
        // quickActionList += '<li class="delete" data-type="reminder"><i class="far fa-trash-alt"></i> Excluir lembrete</li>';
        if(reminder.pending) {
          quickActionList += '<li class="toggle-close" data-type="reminder"><i class="fas fa-check"></i> Concluir lembrete</li>';
        }
        else {
          quickActionList += '<li class="toggle-open" data-type="reminder"><i class="fas fa-check"></i> Reabrir lembrete</li>';
        }
        quickActionList += '<li class="archive" data-type="reminder"><i class="fas fa-archive"></i> Arquivar lembrete</li>';
        quickActionList += '' +
              '</ul>' +
            '</div>';

        element.insertAdjacentHTML('beforeend', quickActionList);
        element.id = 'listItemSelected';

        let els = document.querySelectorAll('#quickActionList > ul > li');

        els.forEach(el => {
          el.addEventListener('click', (event) => {
            if(el.className != 'edit')
              event.stopPropagation();

            this.callQuickAction(el.className, el.getAttribute('data-type'));
          });
        });
      },

      async callQuickAction(action, type) {
        if(action === 'whatsapp') {
          if(type === 'birthday') {
            this.sendBirthdayWhatsapp();
            this.removeBirthdayPersonSelection();
          }
          else {
            this.sendReminderWhatsapp();
            this.removeReminderSelection();
          }
        }
        // else if(action === 'delete') {
        //   this.deleteReminder();
        //   this.removeReminderSelection();
        // }
        else if(action === 'toggle-close' || action === 'toggle-open') {
          this.toggleReminder();
          this.removeReminderSelection();
        }
        else if(action === 'archive') {
          this.archiveReminder();
          this.removeReminderSelection();
        }
        // else if(action == 'confirm') {
        //   await this.api.confirmAppointment(this.eventSelected).then(res => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.$swal('Parabéns...', 'Agendamento confirmado com sucesso!', 'success');
        //
        //     this.getAppointments();
        //     this.removeEventSelection();
        //
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Response Confirm Appointment', res);
        //   }).catch(err => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.removeEventSelection();
        //
        //     let response = err.response;
        //     let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //     this.$swal('Ops...', message, 'error');
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Error Confirm  Appointment', response);
        //   });
        // } else if(action == 'cancel') {
        //   let doCancel = false;
        //   let event = await this.$refs.agenda.getApi().getEventById(this.eventSelected);
        //   let cancelType = 'this';
        //
        //   if(event.extendedProps.appointment.repeat_id != null) {
        //     await this.$swal({
        //       title: 'Excluir agendamento recorrente',
        //       input: 'select',
        //       inputOptions: {
        //         this: 'Este agendamento',
        //         future: 'Este e os agendamentos futuros',
        //         all: 'Todos os agendamentos'
        //       },
        //       showCancelButton: true,
        //       cancelButtonText: 'Cancelar',
        //       inputValidator: (value) => {
        //         cancelType = value;
        //       }
        //     }).then((res) => {
        //       if(res.value) {
        //         doCancel = true;
        //       }
        //     });
        //   }
        //   else {
        //     await this.$swal({
        //       title: 'Você tem certeza?',
        //       text: 'Esta ação não poderá ser desfeita!',
        //       type: 'warning',
        //       showCancelButton: true,
        //       confirmButtonText: 'OK',
        //       cancelButtonText: 'Cancelar',
        //       focusCancel: true
        //     }).then((res) => {
        //       if(res.value) {
        //         doCancel = true;
        //       }
        //     });
        //   }
        //
        //   if(doCancel) {
        //     await this.api.cancelAppointment(this.eventSelected, cancelType).then(res => {
        //       if(this.leavingPage) {
        //         return;
        //       }
        //       this.$swal('Parabéns...', (type == 'appointment')?'Agendamento cancelado com sucesso!':'Bloqueio removido com sucesso!', 'success');
        //
        //       this.getAppointments();
        //       this.removeEventSelection();
        //
        //       if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //         console.log('Response Cancel Appointment', res);
        //     }).catch(err => {
        //       if(this.leavingPage) {
        //         return;
        //       }
        //       this.removeEventSelection();
        //
        //       let response = err.response;
        //       let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //       this.$swal('Ops...', message, 'error');
        //       if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //         console.log('Error Cancel  Appointment', response);
        //     });
        //   }
        // } else if(action == 'hide') {
        //   await this.api.hideAppointment(this.eventSelected).then(res => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.$swal('Parabéns...', 'Agendamento escondido com sucesso!', 'success');
        //
        //     this.getAppointments();
        //     this.removeEventSelection();
        //
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Response Cancel Appointment', res);
        //   }).catch(err => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.removeEventSelection();
        //
        //     let response = err.response;
        //     let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //     this.$swal('Ops...', message, 'error');
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Error Cancel  Appointment', response);
        //   });
        // } else if(action == 'showup') {
        //   await this.api.showupAppointment(this.eventSelected).then(res => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.$swal('Parabéns...', 'Presença registrada com sucesso!', 'success');
        //
        //     this.getAppointments();
        //     this.removeEventSelection();
        //
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Response Show Up Appointment', res);
        //   }).catch(err => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.removeEventSelection();
        //
        //     let response = err.response;
        //     let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //     this.$swal('Ops...', message, 'error');
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Error Show Up Appointment', response);
        //   });
        // } else if(action == 'miss') {
        //   await this.api.missAppointment(this.eventSelected).then(res => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.$swal('Parabéns...', 'Falta registrada com sucesso!', 'success');
        //
        //     this.getAppointments();
        //     this.removeEventSelection();
        //
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Response Miss Appointment', res);
        //   }).catch(err => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.removeEventSelection();
        //
        //     let response = err.response;
        //     let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //     this.$swal('Ops...', message, 'error');
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Error Miss  Appointment', response);
        //   });
        // } else if(action == 'start-attendance') {
        //   await this.api.startAttendanceAppointment(this.eventSelected).then(res => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     if(res.status == 201) {
        //       let attendanceData = res.data;
        //       if(attendanceData.appointment.telehealth && attendanceData.telehealth_attendance != null) {
        //         window.open(this.$router.resolve({path: '/pacientes/'+attendanceData.patient_id+'/teleconsulta/'+attendanceData.telehealth_attendance.id}).href);
        //         this.removeEventSelection();
        //       }
        //       else {
        //         this.$router.push({path: '/pacientes/'+res.data.patient_id }).catch(() => {});
        //       }
        //
        //       // this.eventBus.$emit('ATTENDANCE_STARTED', res.data);
        //     }
        //
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Response Start Attendance Appointment', res);
        //   }).catch(err => {
        //     if(this.leavingPage) {
        //       return;
        //     }
        //     this.removeEventSelection();
        //
        //     let response = err.response;
        //     let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos iniciar este atendimento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';
        //
        //     this.$swal('Ops...', message, 'error');
        //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        //       console.log('Error Start Attendance  Appointment', response);
        //   });
        // }
      },

      sendBirthdayWhatsapp() {
        if(!this.selectedBirthdayPerson) {
          return;
        }
        let person = this.selectedBirthdayPerson;
        let message = "Feliz aniversário! Desejamos um dia repleto de alegrias e um ano cheio de saúde.\nAgradecemos por confiar em nós. Parabéns!";
        window.open('https://wa.me/55'+person.cellphone.replace(/\D/g, '')+'?text='+encodeURIComponent(message));
      },

      removeBirthdayPersonSelection() {
        this.selectedBirthdayPerson = null;
        if (document.getElementById('quickActionList') != null)
          document.getElementById('quickActionList').remove();
        if (document.getElementById('listItemSelected') != null)
          document.getElementById('listItemSelected').id = '';
      },

      removeReminderSelection() {
        this.selectedReminder = null;
        if (document.getElementById('quickActionList') != null)
          document.getElementById('quickActionList').remove();
        if (document.getElementById('listItemSelected') != null)
          document.getElementById('listItemSelected').id = '';
      },

      sendReminderWhatsapp() {
        let reminder = this.selectedReminder;
        if(!reminder) {
          return;
        }
        let message = "Olá, "+reminder.patient+", estou entrando em contato para lembrar " + (reminder.type_term == 'm' ? 'do seu ' : 'da sua ') + reminder.type.toLowerCase() + ".\n" + reminder.description;
        window.open('https://wa.me/55'+reminder.cellphone.replace(/\D/g, '')+'?text='+encodeURIComponent(message));
      },

      toggleReminder() {
        let reminder = this.selectedReminder;
        if(!reminder) {
          return;
        }
        this.eventBus.$emit('IS_LOADING', true);
        this.canPerformAction = false;
        this.api.togglePersonReminder(reminder.patient_id, reminder.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          if (res.status == 204) {
            reminder.pending = !reminder.pending;
          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao concluir o lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Finish Reminder', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          this.$swal('Ops...', 'Não conseguimos concluir este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Finish Reminder', err.response);
        });
      },

      archiveReminder() {
        let reminder = this.selectedReminder;
        if(!reminder) {
          return;
        }
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Arquivar lembrete',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.archivePersonReminder(reminder.patient_id, reminder.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.dashboardData.reminders = this.dashboardData.reminders.filter(r => r.id != reminder.id);

                this.$swal('Uhull \\o/', 'O lembrete foi arquivado com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao arquivar o lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Archive Reminder', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos arquivar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Archive Reminder', err.response);
            });
          }
        });
      },
      async callDirecting(directing) {
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.api.callDirecting(directing.directing_sector_id, directing.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          this.$swal('Parabéns...', 'Paciente chamado com sucesso!', 'success');

          this.loadDirectingSectorData(res.data);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Call Directing', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos chamar este paciente! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Call Directing', response);
        });
      },
      showDirectingModal(directing) {
        this.directingForm.id = directing.id;
        this.directingForm.agenda_id = directing.appointment.agenda_id;
        this.$bvModal.show('directing-modal');
      },
      resetDirectingModal() {
        this.directingForm = {
          id: null,
          agenda_id: null,
          directing_sector: null,
          professional: null
        };
      },
      sectorSelected(selectedOption) {
        this.directingSectorProfessionalOptions = this.directingSectorProfessionals[selectedOption.value].filter(professional => professional.agenda_ids.indexOf(this.directingForm.agenda_id) >= 0).sort((a, b) => a.name.localeCompare(b.name));
        if(this.directingForm.professional != null && !this.directingSectorProfessionalOptions.find(professional => professional.value == this.directingForm.professional.value)) {
          this.directingForm.professional = null;
        }
      },
      loadDirectingSectorData(data) {
        this.dashboardData.pending_directings = data.pending_directings;
      },
      async saveDirecting() {
        if(!this.canPerformAction)
          return false;
        const isValid = await this.$refs.directingForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        let directingData = {
          id: this.directingForm.id,
          professional_id: this.directingForm.professional != null ? this.directingForm.professional.value : null
        };
        await this.api.createDirecting(this.directingForm.directing_sector.value, directingData).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          this.$swal('Parabéns...', 'Paciente encaminhado com sucesso!', 'success');

          this.loadDirectingSectorData(res.data);
          this.$bvModal.hide('directing-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Create Directing', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos encaminhar este paciente! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Create Directing', response);
        });
      },
      async endDirecting(directing) {
        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.endDirecting(directing.directing_sector_id, directing.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Parabéns...', 'Encaminhamento encerrado com sucesso!', 'success');

              this.loadDirectingSectorData(res.data);

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response End Directing', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos encerrar este encaminhamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error End Directing', response);
            });
          }
        });
      },
      getStatusTag(directing) {
        let color = '#0F94D8',
            text = 'Aguardando',
            calledBy = '';
        if(directing.call_datetime != null) {
          color = '#28CD6A';
          text = 'Chamado(a)';
          calledBy = '<small class="d-block mt-2">por '+directing.called_by_person.name+'</small>';
        }

        return '<span class="tag" style="background-color: '+color+';">'+text+'</span>'+calledBy;
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .home-dashboard-list {
    padding: 20px 0;
  }
  .agendas-table, .directing-sectors-table, .reminder-table, .birthday-table {
    tr {
      cursor: pointer;
      &:last-child {
        th:first-child, td:first-child {
          border-bottom-left-radius: 4px;
        }
        th:last-child, td:last-child {
          border-bottom-right-radius: 4px;
        }
      }

      th {
        padding: .7rem .5rem;
      }

      td {
        font-size: 14px!important;
        padding: .7rem .5rem;

        .reminder-description {
          font-size: 13px!important;
        }
      }

      .line-through {
        text-decoration: line-through;
      }

      .sector-link {
        color: inherit;
        text-decoration: none;
      }
    }
  }

  .directing-sectors-table td a {
    display: block;
    padding: .7rem .5rem;
  }

  #listItemSelected {
    z-index: 1000 !important;
    background: #ffffff;
  }

  .tag {
    width: 100%;
    padding: 5px 15px;
    color: #ffffff;
    border-radius: 15px;
  }

  #quickActionList {
    z-index: 1000000 !important;
    position: absolute;
    left: calc(100% + 5px);
    top: 0;

    &.day {
      left: unset;
      right: unset;

      top: calc(100% + 5px);
    }

    &.bottom {
      top: unset;
      bottom: 0;

      &.day {
        bottom: calc(100% + 5px);
      }
    }

    &.left {
      left: unset;
      right: calc(100% + 5px);
    }

    &.mobile {
      left: 0;
      bottom: -110%;

      ul {
        li {
          padding: 5px;
          font-size: 1.1em;
        }
      }
    }

    ul {
      white-space: nowrap;
      margin-bottom: 0;

      li {
        width: 100%;
        padding: 5px 25px 5px 5px;
        border-radius: 5px;
        margin-bottom: 5px;
        color: #ffffff;
        transition: all 0.5s;
        font-weight: normal !important;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        i {
          margin-right: 5px;
        }

        &.whatsapp {
          background-color: $ufoGreen;
        }

        &.toggle-close {
          background-color: $waikawaGray;
        }

        &.toggle-open {
          background-color: $dullLime;
        }

        &.archive {
          background-color: $pictionBlue;
          //background-color: $majorelleBlue;
        }

        &:hover {
          width: calc(100% - 15px);
        }
      }
    }
  }
</style>
